module.exports = __webpack_public_path__ + "img/statistic-screen-4.1fff676.jpg";